import moment from 'moment';
import {CMS} from '@client/util/constants/cms';
import {DATE_FORMAT_DB} from '@client/util/constants';
import {format} from 'date-fns';
import parseISO from 'date-fns/parseISO';
import cloneDeep from 'lodash.clonedeep';

// are we USD only?
export const toMoney = (number) => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(number);

// normalize means multiply by 100
export const toPercent = (data, normalize = true) => `${((normalize ? 100 : 1) * Number.parseFloat(data)).toFixed(2)}%`;

export const toDate = (data) => {
  const date = data instanceof moment ? data : moment(data);

  // if it's not a valid date, just return the input?
  return date.isValid() ? date.format('YYYY-MM-DD') : data;
};

export const toHeaderCurrency = (total, decimals = 2) => {
  // eslint-disable-next-line no-param-reassign
  total = Number.parseFloat(total, decimals);
  let neg = false;

  if (total < 0) {
    neg = true;
    // eslint-disable-next-line no-param-reassign
    total = Math.abs(total);
  }

  return (
    (neg ? '-' : '') +
    Number.parseFloat(total, 10)
      .toFixed(decimals)
      .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      .toString()
  );
};

export const toDecimal = (total, decimals) => {
  // this does not round
  const totalString = total.toString();

  if (!decimals) {
    return totalString;
  }

  if (!totalString.includes('.')) {
    return Number.parseFloat(totalString);
  }

  return totalString.slice(0, totalString.indexOf('.') + (decimals + 1));
};

export const formatDateToDb = (date, dateFormat = DATE_FORMAT_DB) => format(parseISO(date), dateFormat);

export const toBackslashDate = (date) => formatDateToDb(date, 'MM/dd/yyyy');

export const toLongDateFormat = (date) => formatDateToDb(date, 'MMMM dd, yyyy');

export const toCurrency = (total) =>
  // eslint-disable-next-line no-restricted-globals
  Number.isNaN(total) || total === '' || total === null
    ? null
    : `$ ${total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;

export const cmsFormat = (cmsVariables, cmsCopy, routerName) => {
  let exist = false;
  let result = cmsCopy;

  if (CMS[routerName]) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (const k in cmsVariables) {
      exist = CMS[routerName].includes(k);
      if (exist) {
        result = result.replace(`[${k}]`, cmsVariables[k]);
      }
    }

    return result;
  }

  return false;
};

export const abbreviateNumber = (num, fixed = 2) => {
  if (num === null) {
    return null;
  }

  if (num === 0) {
    return '0';
  }

  const b = num.toPrecision(2).split('e');
  const k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3);
  // eslint-disable-next-line no-restricted-properties, prefer-exponentiation-operator
  const c = k < 1 ? num.toFixed(fixed) : (num / Math.pow(10, k * 3)).toFixed(fixed);
  const d = c < 0 ? c : Math.abs(c);
  const e = d + ['', 'K', 'M', 'B', 'T'][k];

  return e;
};

export const removeExtraWhiteSpace = (dataObject, fields) => {
  const data = cloneDeep(dataObject);

  fields.forEach((field) => {
    if (typeof data[field] === 'string') {
      data[field] = data[field].replace(/ +/g, ' ');
      if (data[field].trim()) {
        data[field] = data[field].trim();
      }
    }
  });

  return data;
};
